module.exports = __webpack_public_path__ + "static/stageSet2-ee44d34641493a784d04eb618af301a9.jpg";